import React from 'react';
import { Link } from 'react-router-dom';

const columns = [
  {
    title: 'Platform',
    links: [
      { to: '/content', label: 'Syllabus tracking' },
      { to: '/new-lesson', label: 'Book a lesson' },
      { to: '/authenticate?mode=signup', label: 'Become a tutor' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/team', label: 'Our team' },
      { to: '/about', label: 'About' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy-policy', label: 'Privacy policy' },
      { to: '/terms-and-conditions', label: 'Terms & conditions' },
    ],
  },
];

const socials = [
  {
    label: 'X',
    path: 'M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z',
  },
  {
    label: 'YouTube',
    path: 'M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z',
  },
  {
    label: 'LinkedIn',
    path: 'M4.98 3.5C4.98 4.881 3.87 6 2.5 6S.02 4.881.02 3.5C.02 2.12 1.13 1 2.5 1s2.48 1.12 2.48 2.5zM.24 8h4.52V24H.24V8zm7.5 0h4.33v2.19h.06c.6-1.14 2.07-2.34 4.26-2.34 4.56 0 5.4 3 5.4 6.89V24h-4.51v-7.36c0-1.76-.03-4.02-2.45-4.02-2.45 0-2.83 1.91-2.83 3.89V24H7.74V8z',
  },
];

const Footer = () => (
  <footer className="border-t border-ink-900/[0.08] bg-base-200/40 dark:border-white/10">
    <div className="section-shell py-16">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-brand-500 to-brand-700 text-sm font-bold text-white">
              T
            </span>
            <span className="text-[17px] font-bold tracking-tight">Tütr.ai</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-base-content/55">
            UK tutoring built around the exam your teen is actually sitting — with the tech to
            prove it&apos;s working.
          </p>
          <div className="mt-6 flex gap-2">
            {socials.map((social) => (
              <Link
                key={social.label}
                to="/"
                aria-label={social.label}
                className="grid h-9 w-9 place-items-center rounded-lg border border-ink-900/[0.08] text-base-content/50 transition hover:border-brand-500/40 hover:text-brand-600 dark:border-white/10 dark:hover:text-brand-400"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  className="h-4 w-4 fill-current"
                  aria-hidden="true"
                >
                  <path d={social.path} />
                </svg>
              </Link>
            ))}
          </div>
        </div>

        <div className="grid gap-10 sm:grid-cols-3 lg:col-span-7 lg:col-start-6">
          {columns.map((column) => (
            <div key={column.title}>
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-base-content/40">
                {column.title}
              </p>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-base-content/60 transition hover:text-base-content"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-ink-900/[0.08] pt-7 sm:flex-row sm:items-center sm:justify-between dark:border-white/10">
        <p className="text-xs text-base-content/45">
          &copy;
          {' '}
          {new Date().getFullYear()}
          {' '}
          Tütr.ai. All rights reserved.
        </p>
        <p className="text-xs text-base-content/45">Made in the UK</p>
      </div>
    </div>
  </footer>
);

export default Footer;
